<template>
  <footer>
    <div v-if="!isAuWallet()" class="footer-link mb">
      <div class="container">
        <ul class="link-box">
          <li class="border">|</li>
          <li class="link">
            <router-link :to="{ name: 'sv030' }" target="_blank"
              >会員規約</router-link
            >
          </li>
          <li class="border">|</li>
          <li class="link">
            <a href="https://www.kddi-fs.com/corporate/policy/" target="_blank"
              >プライバシーポリシー</a
            >
          </li>
          <li class="border">|</li>
          <li class="-pcnone"><br /></li>
          <li class="-pcnone border">|</li>
          <li class="link">
            <a
              href="https://www.kddi-fs.com/corporate/sitepolicy/"
              target="_blank"
              >サイトのご利用にあたって</a
            >
          </li>
          <li class="border">|</li>
          <li class="link">
            <a href="https://www.kddi-fs.com/corporate/company/" target="_blank"
              >企業情報</a
            >
          </li>
          <li class="-pcnone border">|</li>
          <li class="-pcnone"><br /></li>
          <li class="border">|</li>
          <li class="link">
            <router-link :to="{ name: 'sv036' }" target="_blank"
              >お問い合わせ</router-link
            >
          </li>
          <li class="border">|</li>
          <li class="link">
            <router-link :to="{ name: 'sv039' }" target="_blank"
              >サイトマップ</router-link
            >
          </li>
          <li class="border">|</li>
        </ul>
      </div>
    </div>

    <div class="footer-text">
      <div class="container position">
        <div class="box-left">
          <CardHeader class="_p-0">
            <p class="heading">貸付条件を確認し、借りすぎに注意しましょう。</p>
          </CardHeader>
          <div class="card-img _mb-sm-30">
            <div class="leftbox">
              <img
                src="@/assets/images/footer/kashikin1.gif"
                class="img-fluid _mb-sm-10"
              />
            </div>
          </div>
        </div>
        <div class="box-right border-box">
          <img src="@/assets/images/footer/kfs_info.gif" class="img-fluid" />
        </div>
      </div>
    </div>

    <div class="footer-service">
      <div class="container">
        <div class="position">
          <small
            >COPYRIGHT © au FINANCIAL SERVICE CORPORATION, ALL RIGHTS
            RESERVED.</small
          >

          <div class="footer-logo">
            <div class="logoleft">
              <img
                src="@/assets/images/footer/kddi_fs_logo.jpg"
                class="img-fluid"
              />
            </div>
            <div class="logoright">
              <img
                src="@/assets/images/footer/kddi_group_logo.jpg"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { auWalletPages } from "@/router";
import { isAuWallet } from "@/utils/UserAgent";
import CardHeader from "@/components/card/CardHeader.vue";

export default {
  name: "FooterMember",
  components: { CardHeader },
  methods: {
    isAuWallet: function () {
      return isAuWallet() && auWalletPages.indexOf(this.$route.name) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.footer-link {
  background-color: #f5f5f5;
  padding-bottom: 30px;
  @include mq-up(md) {
    padding-top: 55px;
    padding-bottom: 55px;
  }
  &.mb {
    @include mq-up(md) {
      padding-top: 23px;
      padding-bottom: 23px;
    }
    @include mq-down(md) {
      padding-top: 30px;
      padding-bottom: 30px;
    }
  }
  > .position {
    @include mq-up(md) {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    @include mq-down(md) {
      padding-left: 0;
      padding-right: 0;
    }
  }
  > .-margin {
    margin-bottom: 30px;
    @include mq-up(md) {
      margin-bottom: 70px;
    }
  }
  .link-box {
    @include mq-down(md) {
      text-align: center;
      line-height: 14px;
    }
    .link,
    .border {
      display: inline-block;
      a {
        font-size: 12px;
        line-height: 14px;
        padding-left: 10px;
        padding-right: 10px;
        @include mq-up(md) {
          padding-left: 20px;
          padding-right: 20px;
          font-size: 14px;
          line-height: 28px;
        }
      }
    }
    .link {
      &:before,
      &:after {
        // vue2環境の余白に寄せるためスペースを挿入
        content: "\0020";
        white-space: pre;
      }
    }
  }
}

.footer-text {
  padding-top: 40px;
  padding-bottom: 40px;
  @include mq-up(md) {
    padding-top: 55px;
    padding-bottom: 55px;
  }
  .position {
    @include mq-up(md) {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
  }
  .box-left {
    width: 100%;
    @include mq-up(md) {
      width: 57%;
    }
    .card-img {
      @include mq-up(md) {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex-flow: row nowrap;
      }
      .leftbox {
        @include mq-up(md) {
          max-width: 428px;
          width: 100%;
        }
        img {
          @include mq-up(md) {
            width: 100%;
          }
        }
      }
    }
    .heading {
      font-size: 14px;
      line-height: 23px;
      @include mq-up(md) {
        font-size: 18px;
        line-height: 42px;
      }
    }
    .card-body {
      p {
        font-size: 10px;
        line-height: 16px;
        @include mq-up(md) {
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }
  .box-right {
    width: 100%;
    @include mq-up(md) {
      width: 37%;
      margin-left: 6%;
    }
    &.border-box {
      padding: 0;
      border: 1px solid $secondary;
      @include mq-up(md) {
        padding: 20px 0;
      }
      > .heading {
        font-size: 14px;
        line-height: 26px;
        text-align: center;
        @include mq-up(md) {
          font-size: 16px;
          line-height: 42px;
        }
      }
      > .position {
        display: flex;
        justify-content: space-between;
        .txt01 {
          font-size: 12px;
          line-height: 24px;
          max-width: 82%;
          float: left;
          @include mq-up(md) {
            max-width: 80%;
            font-size: 14px;
            line-height: 20px;
          }
        }
        .imgbox {
          max-width: 18%;
          @include mq-up(md) {
            max-width: 20%;
            float: right;
          }
        }
      }
    }
  }
}

.footer-service {
  border-top: 1px solid $secondary;
  padding: 30px 0;
  @include mq-up(md) {
    margin-top: 30px;
  }
  @include mq-down(md) {
    padding-top: 15px;
    padding-bottom: 10px;
  }
  .position {
    @include mq-up(md) {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-flow: row nowrap;
    }
  }
  small {
    font-size: 10px;
    @include mq-down(md) {
      display: inline-block;
      text-align: center;
    }
    @include mq-up(md) {
      font-size: 12px;
    }
  }

  .footer-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    @include mq-up(md) {
      justify-content: flex-end;
    }
    .logoleft {
      max-width: 120px;
      width: 100%;
      @include mq-up(md) {
        max-width: 160px;
      }
    }
    .logoright {
      max-width: 68px;
      width: 100%;
      margin-left: 20px;
      @include mq-up(md) {
        max-width: 80px;
      }
    }
  }
}
</style>
